import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function ExpectedPaymentReport() {
  return <ReportForm reportAPI={ ReportAPI.EXPECTED_PAYMENT } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/ExpectedPaymentReport.js